import React from 'react';
import PropTypes from 'prop-types';
import OrderHeader from './OrderHeader';
import OrderActions from './OrderActions';
import OrderGallery from './OrderGallery';
import OrderStatus from './OrderStatus';

const Order = ({ orderNumber, created, orderStatus, products }) => {
    const { currentStatusId, date } = orderStatus;

    return (
        <div className="order">
            <OrderHeader orderNumber={orderNumber} created={created} orderDate={date} currentStatusId={currentStatusId} />
            <OrderStatus orderStatus={orderStatus} />
            <div className="order__content">
                <div className="order__col order__gallery">
                    <OrderGallery products={products} />
                </div>
                <div className="order__col order__actions">
                    <OrderActions orderNumber={orderNumber} orderStatus={orderStatus} />
                </div>
            </div>
        </div>
    );
};

Order.propTypes = {
    orderNumber: PropTypes.string.isRequired,
    created: PropTypes.string.isRequired,
    deliveryTime: PropTypes.string.isRequired,
    orderStatus: PropTypes.object.isRequired,
    products: PropTypes.array.isRequired,
};

export default Order;
